import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavbarProps {
  transparent?: boolean;
}

export default function Navbar({ transparent = false }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';
  const showTransparent = transparent && isHome && !scrolled && !mobileOpen;

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        showTransparent
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
        <Link
          to="/"
          className={`font-heading text-xl font-semibold whitespace-nowrap transition-colors ${
            showTransparent ? 'text-white' : 'text-foreground-900'
          }`}
        >
          欧美精品
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/categories"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              showTransparent
                ? 'text-white/90 hover:text-white'
                : 'text-foreground-700 hover:text-foreground-950'
            } ${location.pathname.startsWith('/categories') ? (showTransparent ? 'text-white' : 'text-primary-600') : ''}`}
          >
            精选分类
          </Link>
          <Link
            to="/articles"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              showTransparent
                ? 'text-white/90 hover:text-white'
                : 'text-foreground-700 hover:text-foreground-950'
            } ${location.pathname.startsWith('/articles') ? (showTransparent ? 'text-white' : 'text-primary-600') : ''}`}
          >
            品牌资讯
          </Link>
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              showTransparent
                ? 'text-white/90 hover:text-white'
                : 'text-foreground-700 hover:text-foreground-950'
            } ${location.pathname === '/about' ? (showTransparent ? 'text-white' : 'text-primary-600') : ''}`}
          >
            关于我们
          </Link>
          <a
            href="#"
            className={`ml-4 px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
              showTransparent
                ? 'bg-white/20 text-white border border-white/30 hover:bg-white/30'
                : 'bg-primary-500 text-white hover:bg-primary-600'
            }`}
          >
            联系我们
          </a>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-8 h-8 flex items-center justify-center ${
            showTransparent ? 'text-white' : 'text-foreground-800'
          }`}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 flex flex-col gap-3">
          <Link to="/categories" className="text-sm font-medium text-foreground-700 py-2">精选分类</Link>
          <Link to="/articles" className="text-sm font-medium text-foreground-700 py-2">品牌资讯</Link>
          <Link to="/about" className="text-sm font-medium text-foreground-700 py-2">关于我们</Link>
          <a href="#" className="inline-block px-5 py-2 rounded-full bg-primary-500 text-white text-sm font-medium text-center">联系我们</a>
        </div>
      )}
    </nav>
  );
}